import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { Theme, createStyles, WithStyles, withStyles, Icon, Typography } from '@material-ui/core'
import autobind from 'autobind-decorator'

const styles = (t: Theme) => createStyles({
    root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        margin: `${t.spacing.unit*2}px 0`,
        height: '50px', 
        width : '100%',
        [t.breakpoints.up('md')]: {
          width: '50%',
        },
    },
    bar: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '20px'
    },
    cursor: {
        position: 'absolute',
        bottom: '20px',
        left: '20px'
    },
    zone: {
        width: '25%',
        border: '1px solid #000000',
        borderCollapse: 'collapse'
    },
    red: {
        background: '#ff3823'
    },
    orange: {
        background: '#FFA834'
    },
    yellow: {
        background: '#FEF8A0'
    },
    green: {
        background: '#92D36E'
    }
});

interface IProps extends WithI18n,
  WithStyles<typeof styles>{
    gauge: string;
}

interface IStates {
}

class CotationGauge extends React.Component<IProps, IStates> {

  render() {
    const {classes} = this.props
    return (
        <>
            <div className={classes.root}>
                <Icon className={classes.cursor} style={{left: this.positionCursor()}}>place</Icon>
                <div className={classes.bar}>    
                    <div className={`${classes.red} ${classes.zone}`} />
                    <div className={`${classes.orange} ${classes.zone}`} />
                    <div className={`${classes.yellow} ${classes.zone}`} />
                    <div className={`${classes.green} ${classes.zone}`} />
                </div>
            </div>
            <div>
                <Typography variant="body2" style={{fontStyle: "italic"}} gutterBottom>{this.explicationRendering()}</Typography>
            </div>
        </>
    )
  }

  @autobind
  private positionCursor(){
    const {gauge} = this.props
    switch(gauge){
        case 'red':
            return 'calc(12.5% - 12px)'
        case 'orange':
            return 'calc(37.5% - 12px)'
        case 'yellow':
            return 'calc(62.5% - 12px)'
        case 'green':
            return 'calc(87.5% - 12px)'
        default: 
            return '0'
    }
  }

  @autobind
  private explicationRendering(){
    const {gauge, t} = this.props
    switch(gauge){
        case 'red':
            return t.cotation_request.gauge.red
        case 'orange':
            return t.cotation_request.gauge.orange
        case 'yellow':
            return t.cotation_request.gauge.yellow
        case 'green':
            return t.cotation_request.gauge.green
        default: 
            return ''
    }
  }

  
}
export default compose(
    withI18n,
    withStyles(styles)
)(CotationGauge)



// WEBPACK FOOTER //
// ./src/shared/Gauge/CotationGauge.tsx